export default __webpack_public_path__ + "static/media/checkmark.b29e92b3.svg";